import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b936bad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-8",
  class: "page-8"
}
const _hoisted_2 = { class: "page-content" }

import ResponsiveImage from '../responsive-image.vue';

interface Emits {
  (event: 'request-collection') :void;
}

export default /*#__PURE__*/_defineComponent({
  emits: ["request-collection"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'request-collection') :void;
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ResponsiveImage, {
        image: require('./bg.png'),
        "image-webp": require('./bg.webp'),
        "mobile-image": require('./bg-m.png'),
        "mobile-image-webp": require('./bg-m.webp'),
        "image-h": 858,
        "image-w": 2022,
        "mobile-image-h": 1347,
        "mobile-image-w": 1371
      }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"]),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('request-collection')))
      })
    ])
  ]))
}
}

})